module.exports = __webpack_public_path__ + "img/bg.a4b976d5.png";